bcn.donate = (function () {

  'use strict';

  var settings = {};

  function updateGiftAid (amount) {
    var displayAmount = amount ? parseFloat(amount, 10).toFixed(2) : 0;
    var giftAidAmount = (amount * 1.25).toFixed(2);
    $('[data-donate-ga-amount]').text(displayAmount);
    $('[data-donate-ga-total]').text(giftAidAmount);
    updateFequency();
  }

  function updateDonationAmount () {

    settings.donateAmountBtn.on('click', function (e) {
      e.preventDefault();
      var donation = $(this).data(settings.donateFixedAmountAttr);
      var parentEl = $(this).parents(settings.donateAmountHolderAttr);
      parentEl.addClass('selected')
        .siblings().removeClass('selected');
      settings.amountInput.val(donation);
      updateGiftAid(donation);
    });

    settings.amountInput.on('change keyup input', function () {
      $(settings.donateAmountHolderAttr).removeClass('selected');
      updateGiftAid($(this).val());
    });

    if ($('#backing_donation_attributes_amount').val()) {
      updateGiftAid($('#backing_donation_attributes_amount').val())
    }

  }

  function updateFequency() {
    if ($('#backing_donation_attributes_frequency').val()) {
      var frequency = $('#backing_donation_attributes_frequency').val().toLowerCase()
      if (frequency === 'annually') {
        frequency = 'annual'
      }
      $('[data-frequency]').text(frequency);
    }
  }

  return {
    init: function () {
      settings = {
        amountInput: $('[data-donate-amount]'),
        donateAmountBtn: $('[data-donate-fixed-amount]'),
        donateAmountHolderAttr: '[data-donate-fixed-amount-holder]',
        donateFixedAmountAttr: 'donate-fixed-amount'
      };
      $('#backing_donation_attributes_frequency').on('change', function() {
        updateFequency();
      })
      updateFequency();
      updateDonationAmount();
    }
  };

})();
